import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import { HEADER_HEIGHT } from '../App';
import { usePageMeta } from '../hooks/usePageMeta';

const TermsOfService: React.FC = () => {
  usePageMeta(
    'Terms of Service | Good Shepherd Accounting',
    'Terms of use for the Good Shepherd Accounting website and tools.'
  );
  return (
    <Box
      sx={{
        minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: 'rgba(27,60,105,0.02)',
        py: 8
      }}
    >
      <Container maxWidth="lg">
        <Paper sx={{ p: 6, borderRadius: 2 }}>
          <Typography variant="h3" gutterBottom color="primary.main" sx={{ mb: 4 }}>
            Terms of Service
          </Typography>

          <Typography variant="body1" paragraph>
            Last updated: {new Date().toLocaleDateString('en-AU')}
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            1. Agreement to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using our website and calculator services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            2. Description of Services
          </Typography>
          <Typography variant="body1" paragraph>
            We provide various financial calculators and tools designed to assist with financial planning and calculations. These tools are provided for informational purposes only and should not be considered as financial advice.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            3. Disclaimer
          </Typography>
          <Typography variant="body1" paragraph>
            Our calculators and tools:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Are for general information purposes only</Typography>
            <Typography component="li" variant="body1">Do not constitute financial advice</Typography>
            <Typography component="li" variant="body1">Should not be relied upon for making financial decisions</Typography>
            <Typography component="li" variant="body1">May not be accurate for your specific circumstances</Typography>
          </Typography>
          <Typography variant="body1" paragraph sx={{ mt: 2 }}>
            We recommend consulting with a qualified financial advisor before making any financial decisions.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            4. User Obligations
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Provide accurate information when using our calculators</Typography>
            <Typography component="li" variant="body1">Use the services only for lawful purposes</Typography>
            <Typography component="li" variant="body1">Not attempt to interfere with the proper functioning of the services</Typography>
            <Typography component="li" variant="body1">Not attempt to access data not intended for you</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            5. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            All content, features, and functionality of our website, including but not limited to text, graphics, logos, calculator tools, and software, are owned by us and protected by Australian and international intellectual property laws.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by law, we exclude all liability for any loss or damage of any kind (including consequential loss) arising from or relating to:
          </Typography>
          <Typography component="ul" sx={{ pl: 4 }}>
            <Typography component="li" variant="body1">Use of our calculators and services</Typography>
            <Typography component="li" variant="body1">Any errors or inaccuracies in calculations</Typography>
            <Typography component="li" variant="body1">Decisions made based on information provided by our services</Typography>
            <Typography component="li" variant="body1">Technical issues or service interruptions</Typography>
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            7. Indemnification
          </Typography>
          <Typography variant="body1" paragraph>
            You agree to indemnify and hold us harmless from any claims, losses, damages, liabilities, and expenses arising from your use of our services or violation of these terms.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            8. Modifications to Service
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify, suspend, or discontinue any part of our services at any time without notice. We will not be liable to you or any third party for any such modifications.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            9. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These terms are governed by the laws of Australia. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts of Australia.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            10. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may update these terms from time to time. Any changes will be posted on this page with an updated revision date. Your continued use of our services after such changes constitutes acceptance of the updated terms.
          </Typography>

          <Typography variant="h5" gutterBottom color="primary.main" sx={{ mt: 4 }}>
            11. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms of Service, please contact us at:
          </Typography>
          <Typography variant="body1" component="div" sx={{ pl: 4 }}>
            Email: nancy@gsaccountants.com.au<br />
            Phone: 0425 660 773<br />
            Address: Turvey St, Padstow NSW
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService; 